"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionBlock = exports.TextBlock = exports.Title = exports.Message = exports.Container = exports.Dismiss = exports.Icon = exports.iconStyles = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var iconStyles = function iconStyles(_ref) {
  var _theme$brand$colors$p, _theme$brand, _theme$brand$colors, _theme$message;

  var theme = _ref.theme;
  return (0, _deepExtend["default"])({
    flexShrink: "0",
    objectFit: "contain",
    alignSelf: "center",
    padding: "2px",
    maxHeight: "40px !important",
    maxWidth: "40px !important",
    path: {
      fill: (_theme$brand$colors$p = theme === null || theme === void 0 ? void 0 : (_theme$brand = theme.brand) === null || _theme$brand === void 0 ? void 0 : (_theme$brand$colors = _theme$brand.colors) === null || _theme$brand$colors === void 0 ? void 0 : _theme$brand$colors.primary) !== null && _theme$brand$colors$p !== void 0 ? _theme$brand$colors$p : "#9121c2"
    }
  }, theme === null || theme === void 0 ? void 0 : (_theme$message = theme.message) === null || _theme$message === void 0 ? void 0 : _theme$message.icon);
};

exports.iconStyles = iconStyles;

var Icon = _styledComponents["default"].img.withConfig({
  displayName: "styled__Icon",
  componentId: "sc-16x2xpi-0"
})(iconStyles);

exports.Icon = Icon;

var Dismiss = _styledComponents["default"].button.withConfig({
  displayName: "styled__Dismiss",
  componentId: "sc-16x2xpi-1"
})(function (_ref2) {
  var _theme$brand$colors$p2, _theme$brand2, _theme$brand2$colors;

  var theme = _ref2.theme;
  return (0, _deepExtend["default"])({
    opacity: 0,
    cursor: "pointer",
    position: "absolute",
    top: -10,
    fontFamily: "\"Roboto\", monospace",
    right: -10,
    width: 30,
    height: 30,
    zIndex: 50,
    color: (_theme$brand$colors$p2 = theme === null || theme === void 0 ? void 0 : (_theme$brand2 = theme.brand) === null || _theme$brand2 === void 0 ? void 0 : (_theme$brand2$colors = _theme$brand2.colors) === null || _theme$brand2$colors === void 0 ? void 0 : _theme$brand2$colors.primary) !== null && _theme$brand$colors$p2 !== void 0 ? _theme$brand$colors$p2 : "#9121c2",
    background: "rgba(255, 255, 255, 0.8)",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
    transition: "opacity 100ms ease-in",
    padding: 6,
    border: "none",
    "&:hover": {
      background: "white"
    },
    borderRadius: "100%"
  }, theme === null || theme === void 0 ? void 0 : theme.dismiss);
});

exports.Dismiss = Dismiss;

var Container = _styledComponents["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "sc-16x2xpi-2"
})(["a{display:flex;}padding:0 12px;width:100%;position:relative;border-radius:5px;&:hover ", "{opacity:1;}"], Dismiss);

exports.Container = Container;

var Message = _styledComponents["default"].div.withConfig({
  displayName: "styled__Message",
  componentId: "sc-16x2xpi-3"
})(function (_ref3) {
  var _theme$message2;

  var theme = _ref3.theme;
  return (0, _deepExtend["default"])({
    padding: 12,
    paddingRight: 0,
    fontSize: "12px",
    fontStyle: "normal",
    lineHeight: "14px",
    alignSelf: "center",
    color: "#73819B"
  }, theme === null || theme === void 0 ? void 0 : (_theme$message2 = theme.message) === null || _theme$message2 === void 0 ? void 0 : _theme$message2.contents);
});

exports.Message = Message;

var Title = _styledComponents["default"].div.withConfig({
  displayName: "styled__Title",
  componentId: "sc-16x2xpi-4"
})(function (_ref4) {
  var _theme$message3;

  var theme = _ref4.theme;
  return (0, _deepExtend["default"])({
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "19px",
    letterSpacing: "0em",
    textAlign: "left",
    display: "-webkit-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitLineClamp: "1",
    WebkitBoxOrient: "vertical",
    color: "#24324B"
  }, (_theme$message3 = theme.message) === null || _theme$message3 === void 0 ? void 0 : _theme$message3.title);
});

exports.Title = Title;

var TextBlock = _styledComponents["default"].div.withConfig({
  displayName: "styled__TextBlock",
  componentId: "sc-16x2xpi-5"
})(function (_ref5) {
  var _theme$message4;

  var theme = _ref5.theme;
  return (0, _deepExtend["default"])({
    color: "#73819B",
    marginTop: "1px",
    wordBreak: "break-word",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "16px",
    letterSpacing: "0em",
    textAlign: "left"
  }, (_theme$message4 = theme.message) === null || _theme$message4 === void 0 ? void 0 : _theme$message4.textBlock);
});

exports.TextBlock = TextBlock;

var ActionBlock = _styledComponents["default"].div.withConfig({
  displayName: "styled__ActionBlock",
  componentId: "sc-16x2xpi-6"
})(function (_ref6) {
  var _theme$brand$colors$p3, _theme$brand3, _theme$brand3$colors, _theme$message5;

  var theme = _ref6.theme;
  return (0, _deepExtend["default"])({
    a: {
      display: "inline-block",
      cursor: "pointer",
      border: "none",
      fontSize: 12,
      color: "white",
      backgroundColor: (_theme$brand$colors$p3 = theme === null || theme === void 0 ? void 0 : (_theme$brand3 = theme.brand) === null || _theme$brand3 === void 0 ? void 0 : (_theme$brand3$colors = _theme$brand3.colors) === null || _theme$brand3$colors === void 0 ? void 0 : _theme$brand3$colors.primary) !== null && _theme$brand$colors$p3 !== void 0 ? _theme$brand$colors$p3 : "#9121c2",
      padding: "6px 15px",
      marginTop: 3,
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
      textDecoration: "none",
      "&:active": {
        boxShadow: "none"
      },
      "&:hover": {
        color: "#73819B",
        background: "rgb(0 0 0 / 10%)"
      },
      borderRadius: 4
    }
  }, theme === null || theme === void 0 ? void 0 : (_theme$message5 = theme.message) === null || _theme$message5 === void 0 ? void 0 : _theme$message5.actionBlock);
});

exports.ActionBlock = ActionBlock;